export default __webpack_public_path__ + "static/media/one.4e6e7a7c.png";